<script lang="ts">
  import ToolTip from "$components/+blocks/Tooltip/Tooltip.svelte";
  import cx from "classnames";
  import { user } from "app/stores/auth";
  import { createEventDispatcher } from "svelte";
  import { tooltip } from "app/actions/tooltip";
  import type { Reaction } from "app/models/forums";

  export let enabled: boolean = false;
  export let reaction: Reaction;

  let usersToDisplay: { uuid: string; handle: string }[] = [];

  const dispatch = createEventDispatcher();
  const MAX_USERS = 20;

  $: ({ emoji, userReacted, count, userReactedUuid, reacters } = reaction);

  $: if (reacters?.length) {
    usersToDisplay = reacters.slice(0, MAX_USERS);

    // if the current user has reacted, add "You" to the front and filter them out from the list
    if (userReacted) {
      usersToDisplay = [
        { handle: "You", uuid: $user?.uuid || "" },
        ...usersToDisplay.filter((userInList) => userInList.uuid !== $user?.uuid),
      ];
    }
  }
</script>

<ToolTip headless>
  <div slot="tip">
    {#if reacters?.length}
      <div
        class="hidden max-w-[250px] rounded-md border border-neutral-100 bg-white/95 px-2 py-1 text-center text-xs font-medium text-neutral-500 sm:flex dark:border-white/10 dark:bg-neutral-900/70 dark:text-white dark:backdrop-blur-sm"
      >
        <div class="text-pretty">
          <!-- list of user handles who have reacted -->
          {usersToDisplay.map((user) => user.handle).join(", ")}
          {#if reacters.length > MAX_USERS}
            <span class="text-neutral-400">{` + ${reacters.length - MAX_USERS} more`}</span>
          {/if}
        </div>
      </div>
    {/if}
  </div>

  <button
    use:tooltip
    type="button"
    class={cx(
      "flex h-[20px] items-center gap-1 rounded-lg border-[0.5px] border-black/15 px-1.5 align-middle text-xs transition-colors dark:border-white/15",
      {
        "hover:bg-neutral-100 hover:dark:bg-white/15": enabled,
        "bg-neutral-200 dark:bg-neutral-700": userReacted,
      }
    )}
    disabled={!enabled}
    on:click={() => {
      dispatch("reaction", { emoji, userReactedUuid });
    }}
  >
    {emoji}
    <span class="text-xs font-medium dark:text-neutral-200">{count}</span>
  </button>
</ToolTip>
